var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cw-customer-service"},[_vm._v("\n\t\t客服服务\n  \t")])}
var staticRenderFns = []

export { render, staticRenderFns }